import type { QueueStageValue } from './api.ts'
import { STAGE_LABEL } from './vocabulary.ts'

/** The bench stages, in the order a requisition passes through them. */
export const QUEUE_STAGES = Object.keys(STAGE_LABEL) as readonly QueueStageValue[]

/**
 * The `stage` the queue request carries, for what is ticked under "Etapa".
 *
 * Never empty, and that is the whole point (#536). The server reads an absent
 * stage as its own default -- comercial and conferência, the bench without
 * produção -- and the request drops empty values on the way out. So "nothing
 * ticked", which the control shows as "Todos", used to arrive as "the
 * default" and hide produção under a button saying everything was there.
 * Naming every stage is the only way to ask for all of them.
 *
 * `offered` is what this person's role reaches, or undefined until the session
 * has said. A tick outside it (saved before a role changed, or pasted in a
 * link) is one the control cannot show, so it is not counted as a choice.
 */
export function stagesToAsk(ticked: string, offered: readonly string[] | undefined): string {
  const reachable = QUEUE_STAGES.filter((stage) => offered === undefined || offered.includes(stage))
  const chosen = reachable.filter((stage) => ticked.split(',').includes(stage))
  if (chosen.length > 0) return chosen.join(',')
  // A role offered nothing is refused by the server whatever is asked.
  return (reachable.length > 0 ? reachable : QUEUE_STAGES).join(',')
}
